const BookingTypes = {
    1: 'Pago Completo',
    2: 'Reserva con Pago',
    3: 'Reserva sin pago',
}

export default BookingTypes
